import api from './index'

export default {

    /**
     * Get lead data
     * @param leadId
     * @param params
     */
    get(leadId, params) {
        return api
            .get(`/leads/${leadId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create Manager from lead
     * @param leadId
     * @param data
     */
    createManager(leadId, data) {
        return api
            .post(`/leads/${leadId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Agree to be contacted for the lead
     * @param leadId
     * @param data
     */
    contact(leadId, data) {
        return api
            .post(`/leads/${leadId}/contact`, data)
            .then(response => {
                return response.data
            })
    }

}
